import React from "react";
import { Link } from "react-router-dom";
import { SvgIcon } from "@/core/components/svgIcon/SvgIcon";
import { imageList } from "@/core/utils/imageList";
import { createRoute, ROUTES } from "@/core/constants/app";
import { PartnerResponse } from "../model/types";
import { Tags } from "@/core/components/tags/Tags";

interface PartnerItemProps {
  partner: PartnerResponse;
  expandedSectors: Set<string>;
  onToggleSectorExpansion: (partnerId: string) => void;
  onClick?: () => void;
  isSelected?: boolean;
}

export const PartnerItem: React.FC<PartnerItemProps> = ({
  partner,
  expandedSectors,
  onToggleSectorExpansion,
  onClick,
  isSelected,
}) => {
  const partnerItem = (partner: PartnerResponse) => {
    return (
      <>
        <div className="partner-header">
          <div className="partner-logo">
            <img
              src={partner.logo_uri ? partner.logo_uri : imageList.noOrgimage}
              alt={partner.title}
            />
          </div>
          {partner.sponsored && (
            <div className="sponsor">
              <Tags type="custom" text={"Premium"} />
            </div>
          )}
          <div className="partner-info">
            <h3 className="partner-title">{partner.title}</h3>
            <div className="partner-meta">
              {partner.partner_type.name && (
                <div className="meta-item">
                  <SvgIcon icon="icon-building" />
                  <span>{partner.partner_type.name}</span>
                </div>
              )}
              <div className="meta-item">
                <SvgIcon icon="icon-location" />
                <span>{partner.country.name}</span>
              </div>
              {partner.since && (
                <div className="meta-item">
                  <SvgIcon icon="icon-clock" />
                  <span>{partner.since}</span>
                </div>
              )}
              {partner.size.name && partner.size.name.length > 1 && (
                <div className="meta-item">
                  <SvgIcon icon="icon-users" />
                  <span>{partner.size.name}</span>
                </div>
              )}
              {partner.implemented_projects > 0 && (
                <div className="meta-item">
                  <SvgIcon icon="icon-projects" />
                  <span>{partner.implemented_projects} projects</span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="partner-sectors">
          {expandedSectors.has(partner.id) ? (
            <>
              {partner.sectors.map((sector) => (
                <span key={sector.id} className="sector-tag">
                  {sector.name}
                </span>
              ))}
              <span
                className="sector-tag more-count"
                onClick={() => onToggleSectorExpansion(partner.id)}
              >
                less
              </span>
            </>
          ) : (
            <>
              {partner.sectors.slice(0, 3).map((sector) => (
                <span key={sector.id} className="sector-tag">
                  {sector.name}
                </span>
              ))}
              {partner.sectors.length > 3 && (
                <span
                  className="sector-tag more-count"
                  onClick={() => onToggleSectorExpansion(partner.id)}
                >
                  +{partner.sectors.length - 3}
                </span>
              )}
            </>
          )}
        </div>
      </>
    );
  };

  if (onClick === undefined) {
    return (
      <Link
        to={createRoute(ROUTES.PARTNER_DETAILS, { id: partner.id })}
        key={partner.id}
        className="partner-item eu-card"
      >
        {partnerItem(partner)}
      </Link>
    );
  } else {
    return (
      <div
        onClick={onClick}
        key={partner.id}
        className={`partner-item eu-card ${isSelected ? "selected" : ""}`}
      >
        {partnerItem(partner)}
        {isSelected && (
          <button
            className="remove-org-btn"
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "#006FCB",
              color: "white",
              border: "none",
              borderRadius: "5px",
              width: "20px",
              height: "20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
            >
              <path
                d="M10 3L4.5 8.5L2 6"
                stroke="white"
                stroke-width="1.6666"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        )}
      </div>
    );
  }
};
